import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    files: {}
  },

  mutations: {
    setFiles (state, { list, memberId }) {
      const files = { ...state.files }
      files[memberId] = list
      state.files = files
    }
  },
  getters: {

  },
  actions: {
    getFiles ({ commit, state, dispatch }, memberId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true })
          .then((token) => {
            API.getCampaignFiles(token, memberId)
              .then((res) => {
                commit('setFiles', { list: res.body, memberId })
                resolve(res.body)
              })
              .catch((e) => {
                reject(e)
              })
          }).catch((e) => {
            reject(e)
          })
      })
    },
    addFile ({ commit, state, dispatch }, { memberId, data }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.addCampaignFiles(token, memberId, data)
            .then((res) => {
              dispatch('getFiles', memberId)
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    accept ({ commit, state, dispatch }, fileId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.acceptCampaignFile(token, fileId)
            .then((res) => {
              resolve(true)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    reject ({ commit, state, dispatch }, { fileId, message }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.rejectCampaignFile(token, fileId, message)
            .then((res) => {
              resolve(true)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
